// extracted by mini-css-extract-plugin
module.exports = {"darkTooltip":"SocialLinks_darkTooltip__4FgRl","otherUrls":"SocialLinks_otherUrls__z6_ve"};